import { makePreloadSlot } from '../../../UnicronApp/preloader/PreloadSlot';
import { EvalResult } from '../../services/FlagrService/types';

export const FlagrEvaluationSlot = makePreloadSlot<Record<string, EvalResult>>(
  'FLAGR_EVALUATION_CACHE',
  {},
);
